import { get, post } from '@/redux/requests/api.js';
import { cleanObject, toSafeString } from '@shared/utils';

export const getPieveAuthMe = ({ callback = undefined, authToken = undefined, companyId = undefined, userId = undefined, deferStateCommit = false, signal = undefined } = {}) => {
  return get('/v1/pieve/auth/me', {
    action: deferStateCommit ? undefined : 'GET_PIEVE_AUTH_ME',
    loader: 'getPieveAuthMe',
    callback,
    authToken,
    companyId,
    signal,
    onResponse: deferStateCommit
      ? (responseShape) => {
          if (responseShape?.data?.success !== true) {
            return responseShape;
          }

          return {
            ...responseShape,
            data: responseShape.data.data
          };
        }
      : undefined,
    meta: userId
      ? {
          userId
        }
      : undefined
  });
};

export const getPieveImpersonationOptions = ({ search = undefined, callback = undefined, authToken = undefined } = {}) => {
  return get('/v1/pieve/auth/impersonation/options', {
    loader: 'getPieveImpersonationOptions',
    callback,
    authToken,
    query: cleanObject(
      {
        search: search === undefined || search === null ? undefined : String(search)
      },
      { strict: true }
    )
  });
};

export const startPieveImpersonation = ({ userId, companyId } = {}) => {
  const normalizedCompanyId = toSafeString(companyId);

  return post('/v1/pieve/auth/impersonation/start', {
    loader: 'startPieveImpersonation',
    data: {
      userId,
      ...(normalizedCompanyId ? { companyId: normalizedCompanyId } : {})
    }
  });
};
